export default (params) => ({
  trigger: {
    name: 'product_specifications.view_element',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'specifications',
          'short_specifications',
          'composed_content',
        ],
      },
    },
    event: {
      name: 'view_content',
      params: {
        content: null,
        index: null,
        total_indices: null,
      },
    },
    nonInt: true,
  },
});
